import initialState from '../store/initialState'
import vouchersTypes from '../constants/vouchersTypes'

export default function vouchersReducer(state = initialState.vouchers, action) {
  switch (action.type) {

    case vouchersTypes.set_errors: {
      return {
        ...state,
        errors: action.payload
      }
    }

    case vouchersTypes.reset_voucher: {
      return {
        ...initialState.vouchers,
        items: state.items,
        voucher: state.voucher,
        totals: state.totals,
        pagination: state.pagination
      }
    }

    case vouchersTypes.clear_voucher: {
      return {
        ...initialState.vouchers,
        voucher: {
        },
        items: state.items,
        totals: state.totals,
        pagination: state.pagination,
      }
    }
    // autofill
    case vouchersTypes.autofill.request: {
      return {
        ...state
      }
    }

    case vouchersTypes.autofill.success: {
      return {
        ...state,
        autofill: action.payload
      }
    }

    case vouchersTypes.autofill.failure: {
      return {
        ...state
      }
    }

    case vouchersTypes.autofill.clear: {
      return {
        ...state,
        autofill: []
      }
    }

    // GET
    case vouchersTypes.get.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        errors: []
      }
    }

    case vouchersTypes.get.success: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        voucher: action.payload,
        errors: []
      }
    }

    case vouchersTypes.get.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        errors: action.payload
      }
    }

    // UPDATE
    case vouchersTypes.update.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        must_redirect: false,
        errors: []
      }
    }

    case vouchersTypes.update.success: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        must_redirect: true,
        errors: [],
        voucher: action.payload
      }
    }

    case vouchersTypes.update.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        must_redirect: false,
        errors: action.payload
      }
    }

    // INDEX
    case vouchersTypes.index.request: {
      return {
        ...state,
        fetching: true,
        fetched: false,
        errors: []
      }
    }

    case vouchersTypes.index.success: {
      if (action.payload.serial && state.serial && action.payload.serial < state.serial) {
        // ignore
        // console.log('index request ignored; consequent request already served')
        return {
          ...state
        }
      }
      return {
        ...state,
        fetching: false,
        fetched: true,
        items: action.payload.vouchers,
        pagination: action.payload.pagination,
        totals: action.payload.totals,
        serial: action.payload.serial || 0,
        errors: []
      }
    }

    case vouchersTypes.index.select: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        select_items: action.payload.vouchers,
        errors: []
      }
    }

    case vouchersTypes.index.failure: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      }
    }

    // PUBLISH, UNPUBLISH, REVOKE
    case vouchersTypes.publish.request:{
      return {
        ...state,
        setting_status: true,
        set_status: false
      };
    }

    case vouchersTypes.publish.success:{
      return {
        ...state,
        setting_status: false,
        set_status: true,
        items: action.payload.vouchers,
        totals: action.payload.totals,
        pagination: action.payload.pagination
      };
    }

    case vouchersTypes.publish.single:{
      const {status } = action.payload.voucher
      return {
        ...state,
        setting_status: false,
        set_status: true,
        voucher: {
          ...state.voucher,
          status: status,
        }
      };
    }

    case vouchersTypes.publish.failure:{
      return {
        ...state,
        setting_status: false,
        set_status: false,
        errors: action.payload
      }
    }

    // CREATE
    case vouchersTypes.create.init: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        must_redirect: false,
        errors: []
      }
    }

    case vouchersTypes.create.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        must_redirect: false,
        errors: []
      }
    }

    case vouchersTypes.create.success: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        must_redirect: true,
        voucher: action.payload,
        errors: []
      }
    }

    case vouchersTypes.create.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        must_redirect: false,
        errors: action.payload
      }
    }

    default: {
      return {...state};
    }
  }

}



// WEBPACK FOOTER //
// ./src/js/reducers/vouchersReducer.js